import {Injectable} from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';
import {FirebaseStorageService} from './firebase-storage.service';
import {DocumentDB, DocumentWithID} from '../../interfaces/document.interface';


@Injectable()
export class FirebaseDocumentService {

  constructor(private afs: AngularFirestore,
              private storeService: FirebaseStorageService) {
  }


  /**
   * Get all documents of property
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getDocumentsPerProperty(org_id: string, property_id: string): Observable<DocumentWithID[]> {
    const list = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('documents');

    return list.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as DocumentDB;
        const id = a.payload.doc.id;
        return {id, ...data};
      });
    });
  }


  /**
   * Get all documents of property with tenant permission
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getDocumentsOfTenantPerProperty(org_id: string, property_id: string, tenant_id: string): Observable<DocumentWithID[]> {
    const list = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('documents',
        ref => ref.where('showTenant', '==', true).where('tenant_id', '==', tenant_id));

    return list.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as DocumentDB;
        const id = a.payload.doc.id;
        return {id, ...data};
      });
    });
  }


  /**
   * Add Document to DB @ [organizations > org_id > properties > property_id > documents]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  addDocumentToProperty(org_id: string, property_id: string, formData: any, tenant_id: string): Observable<any> {
    const documentRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('documents');

    console.log('Document add: ', formData);
    // Create Check for file //
    const fileCheck = formData.file;


    // Set variables//
    let path = '';
    let uploadFile: File;
    if (fileCheck) {
      // get File from Files //
      uploadFile = formData.file.files[0];
      path = org_id + '/' + property_id + '/documents/' + uploadFile.name;
    } else {
      return;
    }

    console.log('File', uploadFile);

    const uid = localStorage.getItem('uid');
    // Populate fields on Document object //
    const transaction = documentRef.add({
        fileName: uploadFile.name,
        fileType: uploadFile.type,
        filePath: path,
        created: moment().toISOString(),
        showTenant: formData.showTenant,
        tenant_id: tenant_id,
        createdBy: uid,
      })
    ;

    return this.fromFirebaseAuthPromise(this.storeService.uploadFile(path, org_id, uploadFile)
      .then(() => transaction)
    );


  }


  /**
   * delete document at DB @ [organizations > org_id > properties > property_id > documents > document_id ]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @param {string} imagePath //
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  deleteDocumentFromProperty(org_id: string, property_id: string, document: DocumentWithID): Observable<any> {
    const deleteDocumentRef = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('documents').doc(document.id);

    return this.fromFirebaseAuthPromise(this.storeService.removeFile(document.filePath)
      .then(() => deleteDocumentRef.delete())
      .catch(error => {
        console.log(error);
        return error;
      })
    );
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} document_id
   * @param formValue
   * @returns {Observable<any>}
   */
  editDocumentPermissionFromProperty(org_id: string, property_id: string, document_id: string, formValue: any): Observable<any> {
    const deleteDocumentRef = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('documents').doc(document_id);

    return this.fromFirebaseAuthPromise(deleteDocumentRef.update(formValue));
  }


  /**
   * Convert Promise of Firebase to an Observable
   * @param promise
   * @returns {Observable<any>}
   */
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/document.service.ts